import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { PatternFormat } from 'react-number-format';
import AnimatedComponent from '../Components/AnimatedComponent';
import BaseCombobox from '../Components/BaseCombobox';
import { LanguageContext } from '../Components/LanguageContext';
import RadioButton from '../Components/RadioButton';
import { postMerchantAppeal } from '../api/publicApi';
import handleTransformLang from '../functions/handleTransformLang';
import { toast } from '../lib/toast';
import Layout from '../Layout';
import dealershipPage from '../lang/pages/dealership.json';

const INPUT_CLASS =
  'block w-full border-0 bg-white px-4 py-3 text-[15px] text-text_secondary ring-1 ring-[#aab2bf] transition focus:outline-none focus:ring-2 focus:ring-text_tertiary placeholder:text-[#b2bac7]';
const TABLE_INPUT_CLASS =
  'block w-full border-0 bg-white px-3 py-3 text-[15px] text-text_secondary ring-1 ring-[#aab2bf] focus:outline-none focus:ring-2 focus:ring-text_tertiary';

/*
const createRows = (count, rowFactory) =>
  Array.from({ length: count }, () => rowFactory());

const createIbanRow = () => ({ iban: '', currency: '' });
*/
const DEFAULT_REPEATER_ROWS = 3;
const DEFAULT_IBAN_CURRENCIES = ['TRY', 'USD', 'EUR'];
const EMPTY_MERCHANT_APPEAL_FIELDS = {
  stuffCount: '',
  averageSaleMonthly: '',
  referenceCompanies: '',
};
const DEALERSHIP_AGREEMENT_DOWNLOAD = {
  href: '/downloadables/dealership/sozlesme_ankara.pdf',
  download: 'sozlesme_ankara.pdf',
};
const MODAL_SCROLL_THRESHOLD = 12;
const CONSENT_MODAL_CONTENTS = {
  agreement: {
    title: 'Sözleşme Metni',
    requiresScrollToClose: false,
    sections: [
      {
        heading: 'Genel Hüküm',
        paragraphs: [
          'İŞ BU SÖZLEŞME, BULUTMARKET İLE MÜŞTERİ ARASINDAKİ HER TÜRLÜ TİCARİ İLİŞKİDE UYGULANACAK ESASLARI BELİRLEMEKTE OLUP, BU SÖZLEŞMEDE DÜZENLENMEYEN HUSUSLARDA TÜRK TİCARET KANUNU, BORÇLAR KANUNU, İLGİLİ DİĞER MEVZUAT İLE ÜLKEDE GEÇERLİ TİCARİ TEAMÜLLER GEÇERLİLİĞİNİ KORUYACAKTIR.',
        ],
      },
      {
        heading: 'A-) CARİ HESAP VE İŞLEYİŞİ İLE İLGİLİ DÜZENLEMELER',
        items: [
          'BULUTMARKET; MÜŞTERİ’ye, gerek genel bayilik kuralları gerekse Bulutmarket üzerinden bilgisayar, bilgisayar parçası ve ürünleri elektronik malzeme, cep telefonu gibi sattığı mallardan, verdiği hizmetlerden, kestiği faturalardan, aldığı paralar ve çeklerden, gelen ve gönderilen havale ve dekontlardan dolayı CARİ HESAP tutacaktır. BULUTMARKET’in bu cari hesaba borç ve alacak olarak kaydettiği kalemler kesin olup MÜŞTERİ/BAYİ bu borca karşı dava ve müdafaa hakkından peşinen feragat etmiştir.',
          'BULUTMARKET’İN MÜŞTERİ/BAYİ adına düzenlemiş olduğu satış faturasında ayrıca döviz tutarı belirtilmiş ise, borçlu borcunu faturadaki döviz cinsinden ödemekle yükümlüdür.',
          'MÜŞTERİ/BAYİ, emtia faturasında belirtilen vade içerisinde borcunu BULUTMARKET’e ödemekle yükümlüdür.',
          'BULUTMARKET bu cari hesabın akdinden önce borçlu ile yaptığı her türlü hukuki muamele, fiil ve işlerden dolayı kendi ticari defterindeki borç ve alacağını cari hesabına borç ve alacak kaydetmek hakkına haizdir.',
        ],
      },
    ],
  },
  kvkk: {
    title: 'KVKK Aydınlatma Metni',
    requiresScrollToClose: true,
    sections: [
      {
        heading: '1. Veri Sorumlusu',
        paragraphs: [
          'Bu aydınlatma metni, 24/3/2016 tarihli ve 6698 sayılı Kişisel Verilerin Korunması Kanunu’nun (KVKK) 10. maddesi ile 10.03.2018 tarih ve 30356 sayılı Resmi Gazete yayımlanan Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ kapsamında veri sorumlusu sıfatıyla, Bulutmarket A.Ş. tarafından hazırlanmıştır.',
          'Bulutmarket A.Ş. olarak, kişisel verilerinizi KVKK’ya uygun olarak ve aşağıda belirtilen amaçlar ve sınırlar kapsamında işlemekte ve verilerinizin korunması için gerekli idari ve teknik tedbirleri almaktayız.',
        ],
      },
      {
        heading: '2. İşlenen Kişisel Veriler',
        items: [
          'Kimlik (ad, soyad, imza, anne adı, baba adı, doğum tarihi, doğum yeri, medeni hali, TC kimlik numarası, fotoğraf, TC kimlik fotokopisi)',
          'İletişim (e-mail, telefon numarası, skype adresi)',
          'Lokasyon (ev adresi, konum bilgileri)',
          'Özlük (bordro bilgileri, işe giriş-çıkış kayıtları, özgeçmiş bilgileri)',
          'Müşteri işlem (çağrı merkezi kayıtları, sipariş ve talep bilgisi, fatura, senet, çek bilgileri, gişe dekont bilgileri)',
          'Fiziksel mekân güvenliği (kamera kayıtları)',
          'İşlem güvenliği (IP adresi, MAC adresi, giriş çıkış bilgileri, kullanıcı adı & şifre bilgileri)',
          'Risk yönetimi bilgileri',
          'Finans (kredi kartı, banka bilgileri, IBAN)',
          'Mesleki deneyim (diploma, kurs, eğitim, sertifikalar, transkript bilgileri)',
          'Felsefi inanç, din, mezhep bilgileri',
          'Sağlık bilgileri (kan grubu, sağlık raporu)',
          'Ceza mahkûmiyeti ve güvenlik tedbirleri (adli sicil)',
        ],
      },
      {
        heading: '3. Kişisel Veri İşleme İlkeleri',
        paragraphs: [
          'Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgi kişisel veridir. Kişisel verileriniz aşağıdaki temel ilkeler çerçevesinde işlenmektedir:',
        ],
        items: [
          'Hukuka ve dürüstlük kurallarına uygun olma',
          'Doğru ve güncel olma',
          'Belirli, açık ve meşru amaçlar için işlenme',
          'İşlendikleri amaçla bağlantılı, sınırlı ve ölçülü olma',
          'Gerekli süre kadar muhafaza edilme',
        ],
      },
      {
        heading: '4. Kişisel Veri İşleme Amaçları',
        paragraphs: [
          'Şirketimiz tarafından toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:',
        ],
        items: [
          'Bayiler/Tedarikçilerle süreç yönetimi',
          'Bilgi güvenliği süreçleri',
          'Çalışanlar için iş akdi ve mevzuat yükümlülükleri',
          'Pazarlama süreçleri',
          'Faaliyet denetimi',
          'Satış/pazarlama süreçleri',
          'Yönetim faaliyetleri',
          'Eğitim süreçleri',
          'Erişim yetki yönetimi',
          'Mevzuata uygun faaliyet yürütme',
          'Finans ve muhasebe işlemleri',
          'Hukuk işlerinin takibi',
          'İletişim faaliyetleri',
          'İş sürekliliği sağlama',
          'Satış sonrası destek',
          'Ürün/hizmet üretim ve operasyon yönetimi',
          'Müşteri ilişkileri yönetimi',
          'Müşteri memnuniyeti çalışmaları',
          'Pazarlama analizleri',
          'Reklam/kampanya/promosyon süreçleri',
          'Sözleşme süreçleri',
          'Şirket içi denetim',
          'Yerleşke güvenliği',
          'Strateji oluşturma ve uygulama',
          'İş sağlığı/güvenliği faaliyetleri',
        ],
      },
      {
        heading: '5. Kişisel Verileri Toplamanın Yöntemi ve Hukuki Sebebi',
        paragraphs: [
          'Bulutmarket A.Ş tarafından; fiziksel veya elektronik yöntemlerle toplanan kişisel verileriniz, kanunlarda açıkça öngörülmesi, meşru menfaatler veya açık rızanıza dayanarak KVKK’nın 5. ve 6. maddeleri kapsamında işlenmektedir.',
        ],
      },
      {
        heading: '6. Kişisel Verilerin Aktarımı',
        paragraphs: [
          'Kişisel verileriniz, Kanun’un 8. ve 9. maddeleri uyarınca yurtiçinde hizmet aldığımız tedarikçiler, ERP yazılım hizmet sağlayıcıları, e-fatura entegratörleri, yetkili kamu kurumları ve kanunen yetkili özel kuruluşlarla paylaşılmaktadır. Yurtdışına kişisel veri aktarımı yapılmamaktadır.',
        ],
      },
      {
        heading: '7. Kişisel Veri Sahibinin Kanun’un 11. Maddesindeki Hakları',
        items: [
          'Kişisel veri işlenip işlenmediğini öğrenme',
          'İşlenmişse buna ilişkin bilgi talep etme',
          'İşleme amacını öğrenme',
          'Verilerin aktarıldığı üçüncü kişileri bilme',
          'Düzeltme talep etme',
          'Silme/yok etme talep etme',
          'Otomatik analiz sonucu doğan olumsuz sonuçlara itiraz',
          'Zarar halinde tazminat talep etme',
        ],
        paragraphs: [
          'Taleplerinizi “KVK Başvuru Formu” ile GMK Bulvarı No: 54/B 06570 Maltepe/Ankara adresine, güvenli elektronik imza, mobil imza veya kayıtlı e-posta adresinizle info@bulutmarket.com.tr adresine iletebilirsiniz.',
          'Başvurular en geç 30 gün içinde sonuçlandırılır. Ek maliyet doğarsa KVKK tarafından belirlenen tarifeye göre ücret alınabilir.',
        ],
      },
    ],
  },
};

const isRepeaterRowComplete = (row) =>
  Object.values(row).every(
    (value) => String(value ?? '').trim() !== ''
  );

const canAddRepeaterRow = (rows, defaultRowCount = DEFAULT_REPEATER_ROWS) =>
  rows.length <= defaultRowCount || isRepeaterRowComplete(rows[rows.length - 1]);

const createInitialIbanRows = () =>
  DEFAULT_IBAN_CURRENCIES.map((currency) => ({
    iban: '',
    currency,
  }));

const createInitialFormState = () => ({
  authorizedName: '',
  companyName: '',
  citizenship: 'citizen',
  email: '',
  authorizedIdentityNo: '',
  phone: '',
  mobilePhone: '',
  address: '',
  neighborhood: '',
  district: '',
  postalCode: '',
  city: '',
  country: '',
  companyType: '',
  mersisNo: '',
  idType: 'tax',
  taxNumber: '',
  taxOffice: '',
  invoiceUsageType: '',
  invoiceTaxpayerType: '',
  agreementApproved: '',
  marketingApproved: 'yes',
  kvkkApproved: '',
});

function formatTemplate(template, values = {}) {
  return Object.entries(values).reduce(
    (message, [key, value]) => message.replace(`{${key}}`, String(value ?? '')),
    String(template ?? '')
  );
}

function normalizeText(value) {
  return String(value ?? '').trim();
}

function normalizeDigits(value) {
  return normalizeText(value).replace(/\D/g, '');
}

function normalizeIban(value) {
  return normalizeText(value).replace(/\s+/g, '').toUpperCase();
}

function resolveOptionLabel(options = [], value = '') {
  const selectedOption = options.find(
    (option) => String(option.value) === String(value)
  );

  return selectedOption?.label || normalizeText(value);
}

function buildAddress(address, neighborhood) {
  return [normalizeText(address), normalizeText(neighborhood)]
    .filter(Boolean)
    .join(', ');
}

function extractIbanPayload(rows) {
  return rows.reduce(
    (payload, row) => {
      const currency = normalizeText(row.currency).toUpperCase();
      const iban = normalizeIban(row.iban);

      if (!iban) {
        return payload;
      }

      if (currency === 'TRY') {
        payload.ibanTry = iban;
      }

      if (currency === 'USD') {
        payload.ibanUsd = iban;
      }

      if (currency === 'EUR') {
        payload.ibanEur = iban;
      }

      return payload;
    },
    {
      ibanTry: '',
      ibanUsd: '',
      ibanEur: '',
    }
  );
}

function buildMerchantAppealPayload(formData, ibanRows, options = {}) {
  return {
    companyName: normalizeText(formData.companyName),
    companyType: resolveOptionLabel(options.companyTypes, formData.companyType),
    taxOffice: normalizeText(formData.taxOffice),
    taxNumber: normalizeDigits(formData.taxNumber),
    phoneNumber: normalizeDigits(formData.phone),
    address: buildAddress(formData.address, formData.neighborhood),
    city: resolveOptionLabel(options.cities, formData.city),
    district: resolveOptionLabel(options.districts, formData.district),
    country: resolveOptionLabel(options.countries, formData.country),
    postalCode: normalizeText(formData.postalCode),
    ...EMPTY_MERCHANT_APPEAL_FIELDS,
    name: normalizeText(formData.authorizedName),
    email: normalizeText(formData.email),
    cellphoneNumber: normalizeDigits(formData.mobilePhone),
    ...extractIbanPayload(ibanRows),
  };
}

function resolveSubmitErrorMessage(error, fallbackMessage) {
  const message = normalizeText(error?.message);

  if (
    error?.name === 'AbortError' ||
    !message ||
    message === 'Failed to fetch' ||
    /^Request failed with status \d+$/.test(message)
  ) {
    return fallbackMessage;
  }

  return message;
}

function getIbanErrorKey(currency) {
  return `iban-${String(currency ?? '').toUpperCase()}`;
}

function scrollToFirstError(errors, fieldOrder) {
  if (typeof document === 'undefined') {
    return;
  }

  const firstKey = fieldOrder.find((fieldName) => errors[fieldName]);

  if (!firstKey) {
    return;
  }

  requestAnimationFrame(() => {
    document
      .querySelector(`[data-error-field="${firstKey}"]`)
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}

function withErrorClass(baseClassName, hasError) {
  return hasError
    ? `${baseClassName} ring-2 ring-red-500 focus:ring-red-500`
    : baseClassName;
}

export default function Dealership() {
  return (
    <Layout headData={dealershipPage.head}>
      <InnerPage />
    </Layout>
  );
}

function InnerPage() {
  const { language } = useContext(LanguageContext);

  const [pageContent, setPageContent] = useState(handleTransformLang(dealershipPage));
  const [formData, setFormData] = useState(createInitialFormState);
  const [ibanRows, setIbanRows] = useState(createInitialIbanRows);
  /*
  const [robotChecked, setRobotChecked] = useState(false);
  */
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitState, setSubmitState] = useState('idle');
  const [submitMessage, setSubmitMessage] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    setPageContent(handleTransformLang(dealershipPage));
  }, [language]);

  const visibleFields = [
    {
      type: 'text',
      name: 'authorizedName',
      label: pageContent.fields.authorizedName,
      required: true,
    },
    {
      type: 'text',
      name: 'companyName',
      label: pageContent.fields.companyName,
      required: true,
    },
    {
      type: 'email',
      name: 'email',
      label: pageContent.fields.email,
      required: true,
    },
    {
      type: 'phone',
      name: 'mobilePhone',
      label: pageContent.fields.mobilePhone,
      required: true,
    },
    {
      type: 'phone',
      name: 'phone',
      label: pageContent.fields.phone,
    },
    {
      type: 'text',
      name: 'neighborhood',
      label: pageContent.fields.neighborhood,
    },
    {
      type: 'text',
      name: 'address',
      label: pageContent.fields.address,
    },
    {
      type: 'text',
      name: 'postalCode',
      label: pageContent.fields.postalCode,
    },
    {
      type: 'text',
      name: 'district',
      label: pageContent.fields.district,
    },
    {
      type: 'text',
      name: 'city',
      label: pageContent.fields.city,
    },
    {
      type: 'text',
      name: 'country',
      label: pageContent.fields.country,
    },
    {
      type: 'select',
      name: 'companyType',
      label: pageContent.fields.companyType,
      options: pageContent.options.companyTypes,
      required: true,
    },
    // Endpoint'te karşılığı olmadığı için gizlendi.
    /*
    {
      type: 'radio',
      name: 'idType',
      options: pageContent.options.idTypes,
    },
    */
    {
      type: 'text',
      name: 'taxNumber',
      label: pageContent.fields.taxNumber,
      required: true,
    },
    // Endpoint'te karşılığı olmadığı için gizlendi.
    /*
    {
      type: 'text',
      name: 'mersisNo',
      label: pageContent.fields.mersisNo,
      required: true,
    },
    */
    {
      type: 'text',
      name: 'taxOffice',
      label: pageContent.fields.taxOffice,
      required: true,
    },
    // Endpoint'te karşılığı olmadığı için gizlendi.
    /*
    {
      type: 'select',
      name: 'invoiceTaxpayerType',
      label: pageContent.fields.invoiceTaxpayerType,
      options: pageContent.options.invoiceTaxpayerTypes,
    },
    */
  ];

  const requiredVisibleFields = visibleFields.map((field) => ({
    ...field,
    required: true,
  }));
  const leftColumnFields = requiredVisibleFields.filter((_, index) => index % 2 === 0);
  const rightColumnFields = requiredVisibleFields.filter((_, index) => index % 2 === 1);
  const validationFieldOrder = [
    ...requiredVisibleFields.map((field) => field.name),
    ...ibanRows.map((row) => getIbanErrorKey(row.currency)),
    'agreementApproved',
    'kvkkApproved',
    'marketingApproved',
  ];

  const consentItems = [
    {
      key: 'agreementApproved',
      text: pageContent.consents.agreement.text,
      linkLabel: pageContent.consents.agreement.linkLabel,
      note: pageContent.consents.agreement.note,
      downloadLabel: pageContent.consents.agreement.downloadLabel,
      downloadHref: DEALERSHIP_AGREEMENT_DOWNLOAD.href,
      downloadName: DEALERSHIP_AGREEMENT_DOWNLOAD.download,
      modalType: 'agreement',
      inlineChoices: false,
      linkOnNewLine: true,
      showCompletionTick: true,
    },
    {
      key: 'kvkkApproved',
      text: pageContent.consents.kvkk.text,
      linkLabel: pageContent.consents.kvkk.linkLabel,
      modalType: 'kvkk',
      inlineChoices: false,
      showCompletionTick: true,
    },
    {
      key: 'marketingApproved',
      text: pageContent.consents.marketing.text,
    },
  ];

  function clearSubmitFeedback() {
    setSubmitState('idle');
    setSubmitMessage('');
  }

  function clearFieldError(fieldName) {
    setFieldErrors((currentErrors) => {
      if (!currentErrors[fieldName]) {
        return currentErrors;
      }

      const nextErrors = { ...currentErrors };
      delete nextErrors[fieldName];
      return nextErrors;
    });
  }

  function updateField(name, value) {
    clearSubmitFeedback();
    clearFieldError(name);
    setFormData((currentData) => ({
      ...currentData,
      [name]: value,
    }));
  }

  function updateRepeaterRow(setter, index, key, value, errorKey) {
    clearSubmitFeedback();
    if (errorKey) {
      clearFieldError(errorKey);
    }
    setter((currentRows) =>
      currentRows.map((row, rowIndex) =>
        rowIndex === index ? { ...row, [key]: value } : row
      )
    );
  }

  function validateForm() {
    const errors = {};

    requiredVisibleFields.forEach((field) => {
      if (!normalizeText(formData[field.name])) {
        errors[field.name] = formatTemplate(
          pageContent.validation.requiredField,
          { field: field.label }
        );
      }
    });

    ibanRows.forEach((row) => {
      if (!normalizeIban(row.iban)) {
        errors[getIbanErrorKey(row.currency)] = formatTemplate(
          pageContent.validation.ibanRequired,
          { currency: row.currency }
        );
      }
    });

    if (formData.agreementApproved !== 'yes') {
      errors.agreementApproved = pageContent.validation.agreementRequired;
    }

    if (formData.kvkkApproved !== 'yes') {
      errors.kvkkApproved = pageContent.validation.kvkkRequired;
    }

    if (formData.marketingApproved !== 'yes') {
      errors.marketingApproved = pageContent.validation.marketingRequired;
    }

    return errors;
  }

  /*
  function addRepeaterRow(setter, rowFactory) {
    clearSubmitFeedback();
    setter((currentRows) => {
      if (!canAddRepeaterRow(currentRows)) {
        return currentRows;
      }

      return [...currentRows, rowFactory()];
    });
  }
  */

  async function handleSubmit(event) {
    event.preventDefault();
    clearSubmitFeedback();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setFieldErrors(validationErrors);
      scrollToFirstError(validationErrors, validationFieldOrder);
      return;
    }

    /*
    if (!robotChecked) {
      toast.error(pageContent.validation.robot);
      setSubmitState('error');
      setSubmitMessage(pageContent.validation.robot);
      return;
    }
    */

    setIsSubmitting(true);

    try {
      const payload = buildMerchantAppealPayload(
        formData,
        ibanRows,
        pageContent.options
      );
      await postMerchantAppeal(payload);
      const successMessage = pageContent.validation.success;

      setFormData(createInitialFormState());
      setIbanRows(createInitialIbanRows());
      setFieldErrors({});
      /*
      setRobotChecked(false);
      */
      setSubmitState('success');
      setSubmitMessage(successMessage);
      toast.success(successMessage);
    } catch (error) {
      console.error(error);
      const errorMessage = resolveSubmitErrorMessage(
        error,
        pageContent.validation.error
      );

      setSubmitState('error');
      setSubmitMessage(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <section
        className="bg-white pb-12"
      >
        <div className="h-1.5 w-full bg-bg_secondary" />

        <div className="container mx-auto max-w-8xl px-4 py-11">
          <div className="flex items-center">
            <Link to="/" className="inline-flex">
              <img
                src="/images/logo.svg"
                alt="Bulutmarket"
                className="h-20 w-auto sm:h-24"
              />
            </Link>
          </div>
        </div>

        <section className="flex flex-col items-center px-4 pb-4 pt-8 text-center">
          <AnimatedComponent
            direction="animate-fade-up animate-duration-500"
            className="w-full max-w-4xl"
          >
            <h1 className="text-3xl font-bold text-text_primary sm:text-4xl">
              {pageContent.title}
            </h1>
            <p className="mt-3 text-sm font-semibold text-[#ff6d4a] sm:text-base">
              {pageContent.note}
            </p>
          </AnimatedComponent>
        </section>
      </section>

      <section className="bg-white pb-24">
        <div className="container mx-auto max-w-8xl px-4">
          <form
            className="mx-auto max-w-6xl"
            onSubmit={handleSubmit}
            autoComplete="off"
            noValidate
          >
            <div className="grid gap-x-12 gap-y-12 xl:grid-cols-2">
              <AnimatedComponent
                direction="animate-fade-right"
                className="space-y-5"
              >
                {leftColumnFields.map((field) => (
                  <Fragment key={field.name}>
                    {renderField({
                      field,
                      value: formData[field.name],
                      error: fieldErrors[field.name],
                      pageContent,
                      updateField,
                    })}
                  </Fragment>
                ))}

                {/*
                Endpoint'te karşılığı olmadığı için gizlendi.
                <FileUploadField
                  id="dealershipAgreement"
                  label={pageContent.files.dealershipAgreement}
                  placeholder={pageContent.placeholders.file}
                  buttonLabel={pageContent.uploadButton}
                  fileName={fileNames.dealershipAgreement}
                  onChange={(event) =>
                    updateFileName(
                      'dealershipAgreement',
                      event.target.files?.[0]
                    )
                  }
                />
                */}

                {/*
                Endpoint'te karşılığı olmadığı için gizlendi.
                <FileUploadField
                  id="taxPlate"
                  label={pageContent.files.taxPlate}
                  placeholder={pageContent.placeholders.file}
                  buttonLabel={pageContent.uploadButton}
                  fileName={fileNames.taxPlate}
                  onChange={(event) =>
                    updateFileName('taxPlate', event.target.files?.[0])
                  }
                />
                */}

                <RepeaterTable
                  label={pageContent.tables.iban.label}
                  primaryColumn={pageContent.tables.iban.primaryColumn}
                  secondaryColumn={pageContent.tables.iban.secondaryColumn}
                  addLabel={pageContent.tables.iban.addLabel}
                  rows={ibanRows}
                  errors={fieldErrors}
                  required
                  canAdd={canAddRepeaterRow(ibanRows)}
                  secondaryReadOnly
                  hideAddButton
                  secondaryOptions={pageContent.options.currencies}
                  selectPlaceholder={pageContent.placeholders.select}
                  onPrimaryChange={(index, value) =>
                    updateRepeaterRow(
                      setIbanRows,
                      index,
                      'iban',
                      value,
                      getIbanErrorKey(ibanRows[index]?.currency)
                    )
                  }
                />
              </AnimatedComponent>

              <AnimatedComponent
                direction="animate-fade-left"
                className="space-y-5"
              >
                {rightColumnFields.map((field) => (
                  <Fragment key={field.name}>
                    {renderField({
                      field,
                      value: formData[field.name],
                      error: fieldErrors[field.name],
                      pageContent,
                      updateField,
                    })}
                  </Fragment>
                ))}

                {/*
                Endpoint'te karşılığı olmadığı için gizlendi.
                <FileUploadField
                  id="signatureCircular"
                  label={pageContent.files.signatureCircular}
                  placeholder={pageContent.placeholders.file}
                  buttonLabel={pageContent.uploadButton}
                  fileName={fileNames.signatureCircular}
                  onChange={(event) =>
                    updateFileName(
                      'signatureCircular',
                      event.target.files?.[0]
                    )
                  }
                />
                */}

                {/*
                Endpoint'te karşılığı olmadığı için gizlendi.
                <FileUploadField
                  id="tradeRegistryGazette"
                  label={pageContent.files.tradeRegistryGazette}
                  placeholder={pageContent.placeholders.file}
                  buttonLabel={pageContent.uploadButton}
                  fileName={fileNames.tradeRegistryGazette}
                  onChange={(event) =>
                    updateFileName(
                      'tradeRegistryGazette',
                      event.target.files?.[0]
                    )
                  }
                />
                */}

                {/*
                Endpoint'te karşılığı olmadığı için gizlendi.
                <RepeaterTable
                  label={pageContent.tables.partners.label}
                  primaryColumn={pageContent.tables.partners.primaryColumn}
                  secondaryColumn={pageContent.tables.partners.secondaryColumn}
                  addLabel={pageContent.tables.partners.addLabel}
                  rows={partnerRows}
                  canAdd={canAddRepeaterRow(partnerRows)}
                  onAdd={() => addRepeaterRow(setPartnerRows, createPartnerRow)}
                  onPrimaryChange={(index, value) =>
                    updateRepeaterRow(setPartnerRows, index, 'partnerName', value)
                  }
                  onSecondaryChange={(index, value) =>
                    updateRepeaterRow(setPartnerRows, index, 'share', value)
                  }
                />
                */}
              </AnimatedComponent>
            </div>

            <div className="mt-20 border-t border-[#eceef3] pt-14">
              <AnimatedComponent
                direction="animate-fade-up animate-duration-500"
                className="space-y-12"
              >
                {consentItems.map((item) => (
                  <ConsentBlock
                    key={item.key}
                    name={item.key}
                    text={item.text}
                    linkLabel={item.linkLabel}
                    note={item.note}
                    downloadLabel={item.downloadLabel}
                    downloadHref={item.downloadHref}
                    downloadName={item.downloadName}
                    linkOnNewLine={item.linkOnNewLine}
                    value={formData[item.key]}
                    yesLabel={pageContent.consents.yes}
                    noLabel={pageContent.consents.no}
                    onChange={(nextValue) => updateField(item.key, nextValue)}
                    inlineChoices={item.inlineChoices}
                    showCompletionTick={item.showCompletionTick}
                    error={fieldErrors[item.key]}
                    onLinkClick={
                      item.modalType
                        ? () => setActiveModal(item.modalType)
                        : undefined
                    }
                  />
                ))}
              </AnimatedComponent>

              <AnimatedComponent
                direction="animate-fade-up animate-duration-500"
                className="mt-14 flex flex-col gap-8 sm:items-start"
              >
                {/*
                <button
                  type="button"
                  onClick={() => {
                    setRobotChecked((currentValue) => !currentValue);
                    clearSubmitFeedback();
                  }}
                  disabled={isSubmitting}
                  className={`flex w-full max-w-[270px] items-center gap-4 border border-[#c8ced8] bg-[#f9f9f9] px-4 py-4 text-left shadow-[0_2px_4px_rgba(15,23,42,0.05)] transition ${
                    isSubmitting
                      ? 'cursor-not-allowed opacity-70'
                      : 'hover:border-[#aab2bf]'
                  }`}
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center border text-sm transition ${
                      robotChecked
                        ? 'border-bg_primary bg-bg_primary text-white'
                        : 'border-[#9ba4b2] bg-white text-transparent'
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="h-4 w-4 fill-current"
                    >
                      <path d="M9.55 16.6 5.4 12.45l-1.4 1.4 5.55 5.55L20 8.95l-1.4-1.4z" />
                    </svg>
                  </span>

                  <span className="flex-1 text-[15px] text-[#5f6673]">
                    {pageContent.captcha.label}
                  </span>

                  <span className="flex flex-col items-center text-[10px] text-[#9aa1ab]">
                    <span className="mb-1 flex h-9 w-9 items-center justify-center rounded-md bg-[#edf2ff] text-[11px] font-bold text-[#5f8ff5]">
                      re
                    </span>
                    <span>{pageContent.captcha.brand}</span>
                  </span>
                </button>
                */}

                <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                  <input
                    type="submit"
                    value={isSubmitting ? pageContent.validation.submitting : pageContent.submit}
                    disabled={isSubmitting}
                    className={`rounded-full bg-gradient-to-r from-button_transition_1 via-button_transition_2 to-button_transition_1 bg-size-200 bg-pos-0 px-8 py-3 text-lg font-bold text-white transition-all duration-500 ${
                      isSubmitting
                        ? 'cursor-not-allowed opacity-70'
                        : 'cursor-pointer hover:bg-pos-100'
                    }`}
                  />

                  {submitMessage ? (
                    <p
                      className={`max-w-xl text-sm leading-6 ${
                        submitState === 'success'
                          ? 'text-[#0a7a46]'
                          : submitState === 'error'
                            ? 'text-[#c14a2a]'
                            : 'text-text_secondary'
                      }`}
                    >
                      {submitMessage}
                    </p>
                  ) : null}
                </div>
              </AnimatedComponent>
            </div>
          </form>
        </div>
      </section>

      <ConsentInfoModal
        modalType={activeModal}
        agreementValue={formData.agreementApproved}
        kvkkValue={formData.kvkkApproved}
        approveLabel={pageContent.consents.approve}
        continueLabel={pageContent.consents.continue}
        onAgreementChange={(nextValue) => updateField('agreementApproved', nextValue)}
        onKvkkChange={(nextValue) => updateField('kvkkApproved', nextValue)}
        onClose={() => setActiveModal(null)}
      />
    </>
  );
}

function renderField({ field, value, error, pageContent, updateField }) {
  if (field.type === 'radio') {
    return (
      <FieldRow emptyLabel fieldKey={field.name} error={error}>
        <RadioGroup
          name={field.name}
          value={value}
          options={field.options}
          onChange={(nextValue) => updateField(field.name, nextValue)}
        />
      </FieldRow>
    );
  }

  if (field.type === 'select') {
    return (
      <FieldRow
        label={field.label}
        required={field.required}
        fieldKey={field.name}
        error={error}
      >
        <SelectField
          name={field.name}
          value={value}
          options={field.options}
          placeholder={pageContent.placeholders.select}
          required={field.required}
          error={Boolean(error)}
          onChange={(nextValue) => updateField(field.name, nextValue)}
        />
      </FieldRow>
    );
  }

  if (field.type === 'phone') {
    return (
      <FieldRow
        label={field.label}
        required={field.required}
        fieldKey={field.name}
        error={error}
      >
        <PatternFormat
          format="0 (###) ### ## ##"
          mask="_"
          value={value}
          required={field.required}
          onValueChange={({ formattedValue }) =>
            updateField(field.name, formattedValue)
          }
          className={withErrorClass(INPUT_CLASS, Boolean(error))}
        />
      </FieldRow>
    );
  }

  return (
    <FieldRow
      label={field.label}
      required={field.required}
      fieldKey={field.name}
      error={error}
    >
      <input
        type={field.type}
        value={value}
        required={field.required}
        inputMode={
          ['authorizedIdentityNo', 'mersisNo', 'taxNumber', 'postalCode'].includes(
            field.name
          )
            ? 'numeric'
            : undefined
        }
        maxLength={field.name === 'postalCode' ? 10 : 80}
        onChange={(event) => updateField(field.name, event.target.value)}
        className={withErrorClass(INPUT_CLASS, Boolean(error))}
      />
    </FieldRow>
  );
}

function FieldRow({
  label,
  required = false,
  emptyLabel = false,
  fieldKey,
  error,
  children,
}) {
  return (
    <div
      data-error-field={fieldKey}
      className="grid gap-2 sm:grid-cols-[minmax(145px,170px)_1fr] sm:items-center"
    >
      {emptyLabel ? (
        <div className="hidden sm:block" />
      ) : (
        <div className="text-left text-[17px] font-semibold text-text_secondary sm:text-right">
          {label}
          {required ? <span className="text-[#ff6d4a]">*</span> : null}
        </div>
      )}
      <div className="space-y-1">
        {children}
        {error ? <p className="text-xs text-red-600">{error}</p> : null}
      </div>
    </div>
  );
}

function SelectField({
  name,
  value,
  options,
  placeholder,
  onChange,
  compact = false,
  required = false,
  error = false,
}) {
  const list = options.map((option) => ({
    key: option.value,
    label: option.label,
  }));

  return (
    <BaseCombobox
      name={name}
      list={list}
      currentValue={value}
      defaultLabel={placeholder}
      onValueChange={onChange}
      compact={compact}
      required={required}
      error={error}
    />
  );
}

function RadioGroup({ name, value, options, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3 py-1 text-[15px] text-text_secondary">
      {options.map((option) => (
        <RadioButton
          key={option.value}
          name={name}
          value={option.value}
          checked={value === option.value}
          onChange={() => onChange(option.value)}
          label={option.label}
        />
      ))}
    </div>
  );
}

/*
function FileUploadField({
  id,
  label,
  placeholder,
  buttonLabel,
  fileName,
  onChange,
}) {
  return (
    <FieldRow label={label}>
      <label className="relative flex h-[3.2rem] w-full cursor-pointer items-center overflow-hidden border border-[#aeb5c0] bg-white pe-[9rem] ps-5 text-[17px] text-text_secondary">
        <span className={fileName ? 'text-text_primary' : 'text-[#aeb6c3]'}>
          {fileName || placeholder}
        </span>

        <span className="absolute inset-y-0 right-0 flex w-[8.65rem] items-center justify-center gap-2">
          <img
            src="/images/hr/gozat_zemin.svg"
            alt=""
            className="absolute inset-0 h-full w-full"
          />
          <img
            src="/images/hr/gozat_zemin_1.svg"
            alt=""
            className="relative h-7 w-auto"
          />
          <span className="relative z-10 text-[17px] font-semibold text-white">
            {buttonLabel}
          </span>
        </span>

        <input
          id={id}
          type="file"
          className="sr-only"
          onChange={onChange}
        />
      </label>
    </FieldRow>
  );
}
*/

function RepeaterTable({
  label,
  primaryColumn,
  secondaryColumn,
  addLabel,
  rows,
  canAdd = true,
  onAdd,
  onPrimaryChange,
  onSecondaryChange,
  secondaryAsSelect = false,
  secondaryReadOnly = false,
  hideAddButton = false,
  errors = {},
  required = false,
  secondaryOptions = [],
  selectPlaceholder = '',
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-[minmax(145px,170px)_1fr] sm:items-start">
      <div className="pt-2 text-left text-[17px] font-semibold text-text_secondary sm:text-right">
        {label}
        {required ? <span className="text-[#ff6d4a]">*</span> : null}
      </div>

      <div>
        <div className="grid grid-cols-[minmax(0,1fr)_112px] gap-1.5">
          <div className="bg-bg_primary px-4 py-3 text-sm font-bold text-white">
            {primaryColumn}
          </div>
          <div className="bg-bg_primary px-4 py-3 text-center text-sm font-bold text-white">
            {secondaryColumn}
          </div>

          {rows.map((row, index) => (
            <Fragment key={`${label}-${index}`}>
              <div
                data-error-field={getIbanErrorKey(row.currency)}
                className="space-y-1"
              >
                <input
                  type="text"
                  value={row.iban || row.partnerName || ''}
                  onChange={(event) =>
                    onPrimaryChange(index, event.target.value)
                  }
                  className={withErrorClass(
                    TABLE_INPUT_CLASS,
                    Boolean(errors[getIbanErrorKey(row.currency)])
                  )}
                />
                {errors[getIbanErrorKey(row.currency)] ? (
                  <p className="text-xs text-red-600">
                    {errors[getIbanErrorKey(row.currency)]}
                  </p>
                ) : null}
              </div>

              {secondaryReadOnly ? (
                <div className="flex items-center justify-center bg-[#f5f7fa] px-3 py-3 text-sm font-semibold text-text_secondary ring-1 ring-[#aab2bf]">
                  {row.currency || row.share || '-'}
                </div>
              ) : secondaryAsSelect ? (
                <SelectField
                  name={`${label}-${index}`}
                  value={row.currency}
                  options={secondaryOptions}
                  placeholder={selectPlaceholder}
                  onChange={(nextValue) => onSecondaryChange(index, nextValue)}
                  compact
                />
              ) : (
                <input
                  type="text"
                  value={row.share}
                  onChange={(event) =>
                    onSecondaryChange(index, event.target.value)
                  }
                  className={TABLE_INPUT_CLASS}
                />
              )}
            </Fragment>
          ))}
        </div>

        {hideAddButton ? null : (
          <button
            type="button"
            onClick={onAdd}
            disabled={!canAdd}
            className={`mt-4 text-sm font-bold uppercase tracking-[0.02em] transition ${
              canAdd
                ? 'text-text_tertiary hover:text-bg_primary'
                : 'cursor-not-allowed text-[#c7ccd5]'
            }`}
          >
            + {addLabel}
          </button>
        )}
      </div>
    </div>
  );
}

function ConsentBlock({
  name,
  text,
  linkLabel,
  note,
  downloadLabel,
  downloadHref,
  downloadName,
  value,
  yesLabel,
  noLabel,
  onChange,
  onLinkClick,
  inlineChoices = true,
  linkOnNewLine = false,
  showCompletionTick = false,
  error,
}) {
  if (!inlineChoices) {
    const hasDownloadAction = Boolean(downloadLabel && downloadHref);

    if (!hasDownloadAction) {
      return (
        <div data-error-field={name} className="space-y-2">
          <div className={`space-y-4 ${error ? 'rounded-md ring-1 ring-red-500 p-3' : ''}`}>
            <div className="flex flex-wrap items-center gap-3">
              <p className="text-[15px] font-semibold leading-7 text-text_secondary">
                {text}
                {linkLabel ? (
                  <button
                    type="button"
                    onClick={onLinkClick}
                    className="ms-2 font-bold text-text_tertiary underline underline-offset-4"
                  >
                    {linkLabel}
                  </button>
                ) : null}
              </p>

              {showCompletionTick && value === 'yes' ? (
                <span
                  className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[#e7852f] text-white"
                  aria-label="Onay tamamlandı"
                  title="Onay tamamlandı"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="h-4 w-4 fill-current"
                  >
                    <path d="M9.55 16.6 5.4 12.45l-1.4 1.4 5.55 5.55L20 8.95l-1.4-1.4z" />
                  </svg>
                </span>
              ) : null}
            </div>

            {note ? (
              <p className="text-[15px] leading-7 text-text_secondary">
                {note}
              </p>
            ) : null}
          </div>

          {error ? <p className="text-xs text-red-600">{error}</p> : null}
        </div>
      );
    }

    return (
      <div data-error-field={name} className="space-y-2">
        <div className={`grid gap-y-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,46rem)] lg:gap-x-10 ${error ? 'rounded-md ring-1 ring-red-500 p-3' : ''}`}>
          <div className="space-y-4">
            {linkOnNewLine ? (
              <>
                <p className="text-[15px] font-semibold leading-7 text-text_secondary">
                  {text}
                </p>

                <div className="flex flex-wrap items-center gap-3">
                  {linkLabel ? (
                    <button
                      type="button"
                      onClick={onLinkClick}
                      className="font-bold text-text_tertiary underline underline-offset-4"
                    >
                      {linkLabel}
                    </button>
                  ) : null}

                  {showCompletionTick && value === 'yes' ? (
                    <span
                      className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[#e7852f] text-white"
                      aria-label="Onay tamamlandı"
                      title="Onay tamamlandı"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="h-4 w-4 fill-current"
                      >
                        <path d="M9.55 16.6 5.4 12.45l-1.4 1.4 5.55 5.55L20 8.95l-1.4-1.4z" />
                      </svg>
                    </span>
                  ) : null}
                </div>
              </>
            ) : (
              <div className="flex flex-wrap items-center gap-3">
                <p className="text-[15px] font-semibold leading-7 text-text_secondary">
                  {text}
                </p>

                {linkLabel ? (
                  <button
                    type="button"
                    onClick={onLinkClick}
                    className="font-bold text-text_tertiary underline underline-offset-4"
                  >
                    {linkLabel}
                  </button>
                ) : null}

                {showCompletionTick && value === 'yes' ? (
                  <span
                    className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[#e7852f] text-white"
                    aria-label="Onay tamamlandı"
                    title="Onay tamamlandı"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="h-4 w-4 fill-current"
                    >
                      <path d="M9.55 16.6 5.4 12.45l-1.4 1.4 5.55 5.55L20 8.95l-1.4-1.4z" />
                    </svg>
                  </span>
                ) : null}
              </div>
            )}

            {note ? (
              <p className="text-[15px] leading-7 text-text_secondary">
                {note}
              </p>
            ) : null}
          </div>

          {downloadLabel && downloadHref ? (
            <div className="space-y-4 lg:pt-[1px]">
              <div className="lg:flex ">
                <a
                  href={downloadHref}
                  download={downloadName}
                  className="group inline-flex shrink-0 items-center gap-3 text-left"
                >
                  <img
                    src="/images/support/ic_sayfa_formlar_icon.svg"
                    alt=""
                    className="h-[2.65rem] w-auto shrink-0 transition-transform duration-200 group-hover:translate-y-[-1px]"
                  />
                  <span className="text-[14px] font-semibold leading-snug text-[#6a7487] transition-colors duration-200 group-hover:text-bg_primary sm:text-[15px]">
                    {downloadLabel}
                  </span>
                </a>
              </div>
            </div>
          ) : null}
        </div>

        {error ? <p className="text-xs text-red-600">{error}</p> : null}
      </div>
    );
  }

  if (note) {
    return (
      <div data-error-field={name} className="space-y-2">
        <div className={`grid gap-y-5 lg:grid-cols-[auto_minmax(0,26rem)] lg:justify-start lg:gap-x-[20px] ${error ? 'rounded-md ring-1 ring-red-500 p-3' : ''}`}>
          <div>
            <p className="text-[15px] font-semibold leading-7 text-text_secondary">
              {text}
              {linkLabel ? (
                <button
                  type="button"
                  onClick={onLinkClick}
                  className="ms-2 font-bold text-text_tertiary underline underline-offset-4"
                >
                  {linkLabel}
                </button>
              ) : null}
            </p>

            {showCompletionTick && value === 'yes' ? (
              <span
                className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[#e7852f] text-white"
                aria-label="Onay tamamlandı"
                title="Onay tamamlandı"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="h-4 w-4 fill-current"
                >
                  <path d="M9.55 16.6 5.4 12.45l-1.4 1.4 5.55 5.55L20 8.95l-1.4-1.4z" />
                </svg>
                </span>
              ) : null}
          </div>

          <div className="lg:pt-[1px]">
            {linkLabel ? (
              <button
                type="button"
                onClick={onLinkClick}
                className="inline-block text-[15px] font-bold text-text_tertiary underline underline-offset-4"
              >
                {linkLabel}
              </button>
            ) : null}
          </div>

          <div className="flex items-center gap-8 text-[15px] text-text_secondary">
            <RadioButton
              name={`${name}-consent`}
              value="yes"
              checked={value === 'yes'}
              onChange={() => onChange('yes')}
              label={yesLabel}
            />

            <RadioButton
              name={`${name}-consent`}
              value="no"
              checked={value === 'no'}
              onChange={() => onChange('no')}
              label={noLabel}
            />
          </div>

          <p className="max-w-md text-[15px] leading-7 text-text_secondary">
            {note}
          </p>
        </div>

        {error ? <p className="text-xs text-red-600">{error}</p> : null}
      </div>
    );
  }

  return (
    <div data-error-field={name} className="space-y-2">
      <div className={`grid gap-6 ${error ? 'rounded-md ring-1 ring-red-500 p-3' : ''}`}>
        <div>
          <p className="text-[15px] font-semibold leading-7 text-text_secondary">
            {text}
            {linkLabel ? (
              <button
                type="button"
                onClick={onLinkClick}
                className="ms-2 font-bold text-text_tertiary underline underline-offset-4"
              >
                {linkLabel}
              </button>
            ) : null}
          </p>

          <div className="mt-4 flex items-center gap-8 text-[15px] text-text_secondary">
          <RadioButton
            name={`${name}-consent`}
            value="yes"
            checked={value === 'yes'}
            onChange={() => onChange('yes')}
            label={yesLabel}
          />

          <RadioButton
            name={`${name}-consent`}
            value="no"
            checked={value === 'no'}
            onChange={() => onChange('no')}
            label={noLabel}
          />
        </div>
      </div>
      </div>

      {error ? <p className="text-xs text-red-600">{error}</p> : null}
    </div>
  );
}

function ConsentInfoModal({
  modalType,
  agreementValue,
  kvkkValue,
  approveLabel,
  continueLabel,
  onAgreementChange,
  onKvkkChange,
  onClose,
}) {
  const content = modalType ? CONSENT_MODAL_CONTENTS[modalType] : null;
  const scrollContainerRef = useRef(null);
  const [canContinue, setCanContinue] = useState(false);
  const [draftChoiceValue, setDraftChoiceValue] = useState('');
  const requiresScrollToClose = content?.requiresScrollToClose ?? false;
  const savedChoiceValue =
    modalType === 'agreement' ? agreementValue : modalType === 'kvkk' ? kvkkValue : '';
  const isContinueDisabled = requiresScrollToClose && !canContinue;

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;

    if (!modalType) {
      setCanContinue(false);
      setDraftChoiceValue('');
      return;
    }

    setDraftChoiceValue(savedChoiceValue === 'yes' ? 'yes' : '');

    if (!requiresScrollToClose) {
      setCanContinue(true);
      return;
    }

    if (!scrollContainer) {
      setCanContinue(false);
      return;
    }

    scrollContainer.scrollTop = 0;
    setCanContinue(
      scrollContainer.scrollHeight - scrollContainer.clientHeight <=
        MODAL_SCROLL_THRESHOLD
    );
  }, [modalType, requiresScrollToClose, savedChoiceValue]);

  function handleScroll(event) {
    if (!requiresScrollToClose) {
      return;
    }

    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    setCanContinue(scrollTop + clientHeight >= scrollHeight - MODAL_SCROLL_THRESHOLD);
  }

  function handleClose() {
    onClose();
  }

  function handleContinue() {
    if (isContinueDisabled) {
      return;
    }

    if (modalType === 'agreement') {
      onAgreementChange(draftChoiceValue === 'yes' ? 'yes' : '');
    }

    if (modalType === 'kvkk') {
      onKvkkChange(draftChoiceValue === 'yes' ? 'yes' : '');
    }

    onClose();
  }

  if (!content) {
    return null;
  }

  return (
    <Transition appear show={Boolean(modalType)} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#111827]/55" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto p-4">
          <div className="flex min-h-full items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:scale-95"
              enterTo="translate-y-0 opacity-100 sm:scale-100"
              leave="ease-in duration-150"
              leaveFrom="translate-y-0 opacity-100 sm:scale-100"
              leaveTo="translate-y-2 opacity-0 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="font-sans w-full max-w-4xl overflow-hidden rounded-[28px] bg-white shadow-[0_28px_70px_rgba(15,23,42,0.24)]">
                <div className="flex items-center justify-between border-b border-[#e6e9ef] px-6 py-5 sm:px-8">
                  <Dialog.Title className="text-xl font-bold text-text_primary sm:text-2xl">
                    {content.title}
                  </Dialog.Title>

                  <button
                    type="button"
                    onClick={handleClose}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-[#d3d9e2] text-lg text-text_secondary transition hover:border-text_tertiary hover:text-text_tertiary"
                    aria-label="Popup kapat"
                  >
                    x
                  </button>
                </div>

                <div
                  ref={scrollContainerRef}
                  onScroll={handleScroll}
                  className="max-h-[70vh] space-y-6 overflow-y-auto px-6 py-6 text-[15px] leading-7 text-text_secondary sm:px-8 sm:py-7 sm:text-[16px]"
                >
                  {content.sections.map((section) => (
                    <div key={section.heading} className="space-y-4">
                      <h3 className="text-[16px] font-bold text-text_primary sm:text-[17px]">
                        {section.heading}
                      </h3>

                      {section.paragraphs?.map((paragraph, index) => (
                        <p key={`${section.heading}-paragraph-${index}`}>{paragraph}</p>
                      ))}

                      {section.items?.length ? (
                        <ol className="space-y-3">
                          {section.items.map((item, index) => (
                            <li key={`${section.heading}-item-${index}`} className="flex gap-3">
                              <span className="font-bold text-text_primary">{index + 1}.</span>
                              <span>{item}</span>
                            </li>
                          ))}
                        </ol>
                      ) : null}
                    </div>
                  ))}
                </div>

                {modalType === 'agreement' || modalType === 'kvkk' ? (
                  <div className="border-t border-[#e6e9ef] px-6 py-4 sm:px-8">
                    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                      <div className="flex items-center gap-8 text-[15px] font-semibold text-text_secondary">
                        <RadioButton
                          type="checkbox"
                          name={`${modalType}-modal-consent`}
                          value="yes"
                          checked={draftChoiceValue === 'yes'}
                          onChange={(event) =>
                            setDraftChoiceValue(event.target.checked ? 'yes' : '')
                          }
                          label={approveLabel}
                          labelClassName="text-[15px] font-semibold leading-7 text-text_secondary"
                        />
                      </div>

                      <button
                        type="button"
                        onClick={handleContinue}
                        disabled={isContinueDisabled}
                        className={`inline-flex items-center justify-center rounded-full bg-gradient-to-r from-button_transition_1 via-button_transition_2 to-button_transition_1 bg-size-200 px-8 py-3 text-lg font-bold text-white transition-all duration-500 ${
                          isContinueDisabled
                            ? 'cursor-not-allowed bg-pos-0 opacity-70'
                            : 'cursor-pointer bg-pos-0 hover:bg-pos-100'
                        }`}
                      >
                        {continueLabel}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="border-t border-[#e6e9ef] px-6 py-4 sm:px-8">
                    <p className="text-sm text-[#7c8698]">
                      {canContinue
                        ? 'Metnin sonuna ulaştınız. Popup kapatılabilir.'
                        : 'Popupı kapatmak için metnin sonuna kadar kaydırın.'}
                    </p>
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
